import { sortBy } from "lodash-es";

// import { getDocumentSimilarity } from "./getDocumentSimilarity";
import { jaroWinklerSimilarity } from "./jaroWinklerSimilarity";

export const getClosestString = (target: string, strings: string[]): string | null => {
    if (strings.length === 0) return null;

    const allDistances = strings.map(str => ({
        str,
        similarity: jaroWinklerSimilarity(target, str)
    }));

    const sortedDistances = sortBy(allDistances, "similarity").reverse();
    return sortedDistances[0]?.str || "";
}